import ReactMarkdown from 'react-markdown'

interface MarkdownRendererProps {
  content: string
  className?: string
}

export default function MarkdownRenderer({ content, className = '' }: MarkdownRendererProps) {
  return (
    <div className={`markdown-content ${className}`}>
      <ReactMarkdown
        components={{
          p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
          strong: ({ children }) => (
            <strong className="font-semibold text-[var(--text-primary,#F0F2F5)]">{children}</strong>
          ),
          em: ({ children }) => <em>{children}</em>,
          ul: ({ children }) => <ul className="list-disc list-inside mb-2 space-y-1">{children}</ul>,
          ol: ({ children }) => (
            <ol className="list-decimal list-inside mb-2 space-y-1">{children}</ol>
          ),
          li: ({ children }) => <li>{children}</li>,
          h3: ({ children }) => (
            <h3 className="font-semibold text-[var(--text-primary,#F0F2F5)] mt-3 mb-1">
              {children}
            </h3>
          ),
          h4: ({ children }) => (
            <h4 className="font-medium text-[var(--text-primary,#F0F2F5)] mt-2 mb-1">
              {children}
            </h4>
          ),
          code: ({ children, className: codeClassName }) => {
            const isBlock = codeClassName?.startsWith('language-')
            if (isBlock) {
              return (
                <pre className="bg-black/20 rounded px-3 py-2 my-2 overflow-x-auto">
                  <code className="text-[12px] font-mono">{children}</code>
                </pre>
              )
            }
            return (
              <code className="bg-black/20 rounded px-1.5 py-0.5 text-[12px] font-mono">
                {children}
              </code>
            )
          },
          pre: ({ children }) => <>{children}</>,
          a: ({ href, children }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--accent,var(--accent))] hover:underline"
            >
              {children}
            </a>
          ),
          blockquote: ({ children }) => (
            <blockquote className="border-l-2 border-[var(--accent,var(--accent))]/30 pl-3 my-2 italic">
              {children}
            </blockquote>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
